import {useQueryClient} from "@tanstack/react-query";
import { USER_CURRENT_KEY } from "../api/public-voissa/users";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ModalContext } from "../ui/components2/ModalManager";
import createLink from "../libs/createLink";
import { useFiltersLocal } from "./useFiltersLocal";

export const MEDIA_LOCKED_LABEL = {
    BIG_PLAN : 'BIG_PLAN',
    FRIENDS : 'FRIENDS',
    MEMBERS_ONLY : 'MEMBERS_ONLY',
    INVISIBLE : 'INVISIBLE',
}

const useMediaLocked = (media)=>{
    const navigate = useNavigate();
    const { openModal } = useContext(ModalContext);
    const {getFilter, setFilter} = useFiltersLocal();
    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    let lockedReason = null;
    if(!(currentUser?._id === media.owner._id)){
        const isBigPlan = (media.kind !== "video" && media.contentReview === 4 && getFilter('bigPlanLocked', true)) ? MEDIA_LOCKED_LABEL.BIG_PLAN : null;
        const isFriendOnly = (media.right === "friends" && media.previewUrl.includes('encrypted')) ? MEDIA_LOCKED_LABEL.FRIENDS : null;
        const isMembersOnly = (!currentUser && media.right !== "guest" && !isFriendOnly) ? MEDIA_LOCKED_LABEL.MEMBERS_ONLY : null;
        const isInvisible = (media.display === false) ? MEDIA_LOCKED_LABEL.INVISIBLE : null;
        lockedReason = isInvisible || isFriendOnly || isMembersOnly || isBigPlan;
    }
    const handleLockedAction = ()=>{
        if(!lockedReason) return false;
        switch (lockedReason) {
            case MEDIA_LOCKED_LABEL.FRIENDS:
                !!currentUser ? navigate(createLink("userProfile", media.owner), { state: { addFriend: true } }) : openModal('EncourageSignup');
                break;
            case MEDIA_LOCKED_LABEL.MEMBERS_ONLY:
                openModal('EncourageSignup');
                break;
            case MEDIA_LOCKED_LABEL.BIG_PLAN:
                setFilter('bigPlanLocked', false);
                break;
            default:
                console.error('No action provided for this locked content');
                return false;
        }
        return true;
    }
    return {locked:!!lockedReason, lockedReason, handleLockedAction};
}

export default useMediaLocked;